import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '~/routes/use-on-load';
import { P2GBox } from '@parcel2go/core-ui';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

// Account-experience My Details tab. Mounts the existing component as-is (current fields
// only - company/VAT/password are deferred). The SmartSend /settings page is untouched.
const MyDetails = lazy(() => import('~/apps/my-details/my-details'));

export default function Component() {
  const { track } = useSmartSendAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.MYDETAILS);

  useOnLoad(() => {
    const title = t('MY_DETAILS_PAGE_TITLE', { defaultValue: 'My Details' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.MYDETAILS });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.MyDetails }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.MyDetails
      }
    });
  });

  return (
    <Tagged tag="screen-my-details">
      <Suspense>
        <P2GBox>
          <MyDetails />
        </P2GBox>
      </Suspense>
    </Tagged>
  );
}

Component.displayName = 'My Details';
